import { createRequest, platform } from "@shared/platform-api/requests"
import { createRequestHook } from "../../createRequestHook"
import { fromPeriodApi, GetPeriodsOutput } from "./utils"
import { isNewPipelinePolicy } from "../../../utils"

export type UseGetPeriodsInput = Readonly<{ policyId: string }>

const getPeriods = createRequest<UseGetPeriodsInput, GetPeriodsOutput>(
  async (input: UseGetPeriodsInput, getToken): Promise<GetPeriodsOutput> => {
    const useNewPipeline = isNewPipelinePolicy(input.policyId)
    const result = await platform(getToken).periods.getPeriods({
      ...input,
      ...(useNewPipeline ? { dbName: `athena` } : {}),
    })
    return fromPeriodApi(result)
  }
)

export const useGetPeriods = createRequestHook<UseGetPeriodsInput, GetPeriodsOutput>(getPeriods)
